import {z} from 'zod'
import {buildEntrySchemaFor} from '../entry'
import {PageSettingsSchema} from './pageSettings'
import {TemplateFreeFormSchema} from './templateFreeForm'
import {TemplateUniverse23WaitlistSchema} from './templateUniverse23Waitlist'

function buildPageSchemaForTemplate<Template extends z.ZodTypeAny>(templateSchema: Template) {
  return buildEntrySchemaFor('containerPage', {
    fields: z.object({
      path: z.string(),
      settings: PageSettingsSchema.optional(),
      template: templateSchema,
      title: z.string(),
    }),
  })
}

const FreeFormPageSchema = buildPageSchemaForTemplate(TemplateFreeFormSchema)
export type FreeFormPage = z.infer<typeof FreeFormPageSchema>

const Universe23WaitlistPageSchema = buildPageSchemaForTemplate(TemplateUniverse23WaitlistSchema)
export type Universe23WaitlistPage = z.infer<typeof Universe23WaitlistPageSchema>

const ContainerPageSchema = z.union([FreeFormPageSchema, Universe23WaitlistPageSchema])
export type ContainerPage = z.infer<typeof ContainerPageSchema>

export function toContainerPage(item: unknown): ContainerPage {
  return ContainerPageSchema.parse(item)
}
